import { useState, useEffect, Fragment } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import LoadingSpinner from '../common/LoadingSpinner';
import FormErrorAlert from './FormErrorAlert';

const UserModalBase = ({
  show,
  title,
  initialValues,
  validate,
  onSubmit,
  onClose,
  submitLabel,
  loadingLabel,
  children,
}) => {
  const [formData, setFormData] = useState(initialValues);
  const [errors, setErrors] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [resetVersion, setResetVersion] = useState(0);

  const resetForm = () => {
    setFormData(initialValues);
    setErrors([]);
    setResetVersion(prev => prev + 1);
  };

  useEffect(() => {
    if (show) {
      resetForm();
    }
  }, [show, initialValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);

    const validationErrors = validate(formData);
    if (validationErrors.length) {
      setErrors(validationErrors);
      return;
    }

    setSubmitting(true);
    const result = await onSubmit(formData);
    setSubmitting(false);

    if (!result.success) {
      setErrors(result.validationErrors ?? [result.error]);
      return;
    }

    resetForm();
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <FormErrorAlert errors={errors} />
          <Fragment key={resetVersion}>
            {children({ formData, setFormData, handleChange })}
          </Fragment>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={submitting}>
            {submitting ? (
              <LoadingSpinner inline message={loadingLabel} />
            ) : (
              submitLabel
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UserModalBase;